module.exports = __webpack_public_path__ + "img/cc.314968eb.svg";